import { FETCH_BILLING_DATES_FAILURE, FETCH_BILLING_DATES_REQUEST, FETCH_BILLING_DATES_RESET, FETCH_BILLING_DATES_SUCCESS, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const fetchBillingDatesData = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BILLING_DATES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_BILLING_DATES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_BILLING_DATES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case FETCH_BILLING_DATES_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default fetchBillingDatesData;
